<template>
  <div>
    <div :class="{ IsLoadingAuthenticated: this.loading }" v-if="this.loading">
      <div id="loadCircleAuthenticated"></div>
    </div>
    <apexchart
      ref="chart"
      type="line"
      height="250"
      :options="this.options"
      :series="getSeries"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: "apexchartline",
  props: {
    data: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    graphLabel: {
      type: String
    }
  },

  data() {
    return {
      options: {
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: true
          }
        },
        dataLabels: {
          enabled: false,
          style: {
            colors: ["#000"],
            fontFamily: "sans-serif"
          }
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "#ffffff"], // takes an array which will be repeated on columns
            opacity: 0
          }
        },
        xaxis: {
          tickAmount: 30,
          categories: this.data.dates,
          convertedCatToNumeric: false
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "0.85rem"
            }
          }
        },
        responsive: [
          {
            breakpoint: 1000,
            options: {
              xaxis: {
                tickAmount: 12,
                categories: this.data.dates,
                convertedCatToNumeric: false
              }
            }
          }
        ]
      }
    };
  },

  computed: {
    getSeries() {
      var series;
      if (this.data.new == undefined){
         series = [
                {
                  name: "Exibições",
                  data: this.data.total
                }
              ];
      } else {
        series = [
                {
                  name: this.graphLabel,
                  data: this.data.total
                },
                {
                  name: "Novos Autenticados",
                  data: this.data.new
                }
              ];
      }
      
      
      return series;
    }
  },
  beforeUpdate() {
    this.$refs.chart.updateOptions({
      xaxis: {
        tickAmount: 30,
        categories: this.data.dates
      },
      colors: ["#f56618", "#6e7374"],
      responsive: [
        {
          breakpoint: 1000,
          options: {
            xaxis: {
              tickAmount: 12,
              categories: this.data.dates,
              convertedCatToNumeric: false
            }
          }
        }
      ]
    });
  }
};
</script>

<style>
@keyframes rotate {
  to {
    transform: rotate(1turn);
  }
}

.IsLoadingAuthenticated {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgb(216, 216, 216);
  opacity: 0.6;
  display: flex;
  justify-content: center;
}
#loadCircleAuthenticated {
  align-self: center;
  border: 6px solid #424242;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border-top-color: #ff9801;
  animation: rotate 1s infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ApexChartLine.vue